
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activatePromoCKB",
      function () {
        return require("private-next-pages/activatePromoCKB.js");
      }
    ]);
  